<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <RouterLink class="brand-logo">
        <vona-logo />
        <h2 class="brand-text text-primary ml-1">
          {{ getAssociation }}
        </h2>
      </RouterLink>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Forgot password V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1"> Esqueceu sua senha? 🔒 </b-card-title>
          <b-card-text class="mb-2">
            Digite seu e-mail e enviaremos instruções para redefinir sua senha
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <b-form-group label="Email" label-for="forgot-password-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="forgot-password-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <av-button
                :loading="loading"
                type="submit"
                variant="primary"
                block
              >
                Resetar
              </av-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <RouterLink :to="{ name: 'auth-login', query: $route.query }">
              <feather-icon icon="ChevronLeftIcon" /> Voltar para o login
            </RouterLink>
          </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { AvButton } from "@/components";
import { useAdministrator } from "@/services";
import store from "@/store/index";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VonaLogo from "@core/layouts/components/Logo.vue";
import { email, required } from "@validations";
import {
  BCardText,
  BCardTitle,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BImg,
  BRow,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { RouterLink } from "vue-router";

export default {
  components: {
    VonaLogo,
    BRow,
    BCol,
    RouterLink,
    BImg,
    BForm,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    AvButton,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: "",
      loading: false,
      sideImg: require("@/assets/images/pages/forgot-password-v2.svg"),
      // validation
      required,
      email,
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/forgot-password-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
    getAssociation() {
      return localStorage.getItem("domain") || "Vona";
    },
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.loading = true;
          useAdministrator
            .requestGetCode(this.userEmail)
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title:
                    "Enviamos um e-mail com as instruções para redefinir sua senha",
                  icon: "CheckIcon",
                  variant: "success",
                },
              });

              this.$store.commit(
                "admin-users/SET_EMAIL_RECOVER",
                this.userEmail
              );
              this.$router.push({
                name: "auth-confirm-code",
                query: this.$route.query,
              });
            })
            .catch(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Ocorreu um erro inesperado",
                  text: "Não foi possível enviar e-mail com as instruções para redefinição de senha",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
